import { Pipe, PipeTransform } from '@angular/core';
import { StoreService } from '@core/services/store/store.service';
import { DateTimeFormat, DATE_TIME_FORMATS, TimeZone, TranslateService } from '@interticket/core';
import { DateTime } from 'luxon';

@Pipe({
  name: 'timezone',
})
export class TimezonePipe implements PipeTransform {

  private userLocale = {
    locale: this.translate.currentLang,
    format: DATE_TIME_FORMATS[this.translate.currentLang],
    timeZone: TimeZone.LOCAL,
  };

  constructor(
    private translate: TranslateService,
    private storeService: StoreService
  ) {
    this.userLocale.timeZone = this.storeService.partnerConfig.general.defaultTimezone;
  }

  transform(dateString: string, format: DateTimeFormat | string = DateTimeFormat.DATETIME_FULL): string {
    const dateTime: DateTime = DateTime.fromISO(dateString);
    if (dateTime.isValid) {
      const dateTimeFormat: string = this.userLocale.format[format] || format;
      return dateTime.setLocale(this.userLocale.locale).setZone(this.userLocale.timeZone).toFormat(dateTimeFormat);
    }
    return '';
  }

}
